<!--
    Styles
-->

<style>


    /* main */

    #deals .container {
        padding-left: 20px;
        padding-right: 20px;
    }


    /* controls */

    #deals a.disabled {
        color: var(--cl-gray);
        cursor: default;
    }


    /* table */

    #deals table {
        width: 100%;
        white-space: nowrap;
        border-collapse: collapse;
    }
    #deals table td,
    #deals table th {
        padding: 0 10px;
    }
    #deals table .heading {
        height: 40px;
    }
    #deals table .row {
        height: 50px;
        border-bottom: 1px solid var(--cl-gray);
    }
    #deals table .row:hover {
        background: var(--cl-blue-light);
    }
    #deals table .row:last-child {
        border-bottom: none;
    }


    /* list */

    #deals .list {
        position: relative;
        overflow-y: scroll;
        cursor: default;
    }
    #deals .list table {
        margin-top: -40px;
    }
    #deals .list .wrap {
        white-space: normal;
    }
    #deals .list .close svg {
        width: 20px;
        height: 20px;
        fill: var(--cl-gray);
    }
    #deals .list .label {
        line-height: 16px;
        border-radius: 2px;
        text-align: center;
        white-space: nowrap;
        padding: 0 5px;
        background: var(--cl-gray-dark);
        color: var(--cl-white);
    }
    #deals .list .label.active {
        background: var(--cl-blue-dark);
    }
    #deals .list .ui-spinner {
        width: 32px;
        height: 32px;
        margin: 10px auto 20px auto;

    }


</style>



<!--
    Template
-->

<template>
    <div id="deals" class="u-col">


        <!-- nav -->

        <layout-nav />


        <!-- filters -->

        <layout-filters class="container" :loading="request && !deals.length" @refresh="load($event)" />


        <!-- heading -->

        <div class="container" :style="{marginRight: scrollWidth + 'px'}">
            <table ref="thead">
                <layout-thead class="heading" :checked="all" @check="selectall" />
            </table>
        </div>


        <!-- list -->

        <div class="list container u-flex" @scroll="scroll" ref="list">
            <div class="u-center cl-gray t16" v-show="loaded && !deals.length">
                物件データが見つかりません
            </div>

            <table ref="tbody">
                <layout-thead class="heading" />
                <tr class="row" v-for="deal in deals" :key="deal.id" @click="select(deal.id)">

                    <td><ui-checkbox :active="selected.includes(deal.id) ? !all : all" /></td>

                    <td
                        v-for="col in columns"
                        :key="[deal.id, col].join('_')"
                        :class="{wrap: variable(col)}"
                    >

                        <!-- done badge -->

                        <span v-if="col === 'done'">
                            <div v-if="!deal.done" class="label active t12">募集</div>
                            <div v-else class="label t12">成約</div>
                        </span>

                        <!-- floor / floors -->

                        <span v-else-if="col === 'floor'">
                            <span v-if="deal.floor">{{ deal.floor }}/{{ deal.building.floorsCount || '?' }}F</span>
                            <span v-else>-</span>
                        </span>

                        <!-- sqm -->

                        <span v-else-if="col === 'sqm'">
                            {{ deal.sqm || deal.totalFloorSqm }}m²
                        </span>

                        <!-- regular fields -->

                        <span v-else>{{ deal | extract(col) | format(col) }}</span>

                    </td>

                    <td>
                        <a class="t-line cl-blue" :class="{disabled: bulk}" @click.stop="edit(deal.id)">編集する</a>
                    </td>

                    <td>
                        <a class="close" :class="{disabled: bulk}" @click.stop="!bulk && del(deal.id)">
                            <icon-close />
                        </a>
                    </td>

                </tr>
                <tr>
                    <td colspan="100%">
                        <ui-spinner ref="spinner" v-show="deals.length && !loaded" />
                    </td>
                </tr>
            </table>


        </div>


        <!-- bulk -->

        <layout-bulk
            v-show="bulk"
            :count="count"
            @cancel="clear"
            @delete="del"
            @add="report"
        />

    </div>
</template>



<!--
    Scripts
-->

<script>


    import {mapState, mapGetters, mapMutations, mapActions} from 'vuex'
    import {date as vdate, price} from '@/common/helpers/parse'
    import {validateParams} from '@/common/helpers/params'
    import scrollWidth from '@/common/helpers/scroll-width'
    import uiCheckbox from '@/components/shared/ui/checkbox.vue'
    import uiSpinner from '@/components/shared/ui/spinner.vue'
    import iconClose from '@/assets/icons/close-fill.svg'
    import layoutNav from '@/components/shared/layout/nav.vue'
    import layoutFilters from './filters.vue'
    import layoutThead from './thead.vue'
    import layoutBulk from './bulk.vue'


    const date = v => vdate(v, true);

    const formats = {
        dealtAt: [date],
        dealPrice: [price, '円'],
        sqm: [undefined, 'm²'],
        landSqm: [undefined, 'm²'],
        'building.builtAt': [date]
    };


    export default {

        components: {
            layoutNav,
            layoutThead,
            layoutBulk,
            layoutFilters,
            uiCheckbox,
            uiSpinner,
            iconClose
        },

        filters: {

            extract (deal, key) {
                return key.split('.').reduce((acc, k) => acc[k], deal);
            },

            format (value, key) {
                if (value === undefined || !value.length) return '-';
                const [fmt = v => v, unit = ''] = formats[key] || [];
                return fmt(value) + unit;
            }

        },

        data () {
            return {
                scrollWidth
            }
        },

        computed: {

            ...mapState('deals', [
                'total',
                'deals',
                'request',
                'loaded',
                'all',
                'selected',
                'columns'
            ]),

            ...mapGetters('deals', [
                'bulk',
                'count'
            ])

        },

        methods: {

            ...mapMutations('search', [
                'setParams'
            ]),

            ...mapMutations('deals', [
                'select',
                'selectall',
                'clear'
            ]),

            ...mapActions('search', {
                add: 'select'
            }),

            ...mapActions('deals', [
                'abort',
                'list',
                'del'
            ]),

            variable (key) {
                return ['building.name', 'building.address'].includes(key);
            },

            setTable () {
                const $htd = this.$refs.thead.children[0].children;
                const $btd = this.$refs.tbody.children[0].children;
                Array.from($htd).forEach(($td, i) => $td.style.width = $btd[i].offsetWidth + 'px');
            },

            scroll () {
                const top = this.$refs.spinner.$el.offsetTop;
                if (!top) return; // spinner is hidden
                const list = this.$refs.list;
                if (list.scrollTop + list.offsetHeight !== list.scrollHeight) return;
                this.load();

            },

            load (refresh) {
                this.list(refresh).then(() => {
                    this.$nextTick(this.setTable);
                });
            },

            report () {
                this.selected.forEach(id => {
                    const {building: {name, loc, ...building}, ...deal} =
                        this.deals.find(deal => deal.id === id);
                    this.add({
                        deal,
                        building: {
                            id: name,
                            name,
                            location: loc,
                            ...building
                        }
                    });
                });
                this.clear();
            },

            edit (id) {
                this.$popup.show('property', {id}, {clearable: false})
                    .then(reload => this.load(reload));
            }

        },

        mounted () {
            this.load();
        },

        watch: {

            '$route.query': {
                immediate: true,
                handler () {
                    const query = validateParams(this.$route.query, {});
                    this.setParams(query);
                    this.load(true);
                }
            }

        },

        destroyed () {
            this.abort();
        }

    }

</script>

